<template>
  <div class="image-component">
    <div
      :class="['image', {'active': active}]"
      v-lazy:background-image=" baseUrl + 'images/'+content.image + (device === 'mobile' ? '_mobile' : '_desktop')+ ($retina && device !== 'mobile'  ? '_2x' : '') +'.jpg'"
    ></div>
    <div v-if="content.dida" class="image-dida overline">
      {{content.dida}}
      <div :class="['line', {'active': active}]"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content", "active"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      device: ''
    };
  },
  created() {
    this.device = window.innerWidth > 768 ? "desktop" : "mobile";
    window.addEventListener("resize", () => {
      this.device = window.innerWidth > 768 ? "desktop" : "mobile";
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
.image-component {
  height: 900px;
  width: 100%;
  background: grey;
  margin: 50px 0;
  overflow: hidden;
  position: relative;
  .image-dida {
    position: absolute;
    bottom: 50px;
    left: 10%;
    background: white;
    width: 300px;
    padding: 20px;
    z-index: 0;
    .line {
      height: 20px;
      width: 0px;
      background: $terna-light-blu;
      position: absolute;
      left: 20px;
      top: 20px;
      z-index: -1;
      transition: all 0.3s ease;
      &.active {
        width: 30px;
      }
    }
  }
  .image {
    height: 100%;
    width: 100%;
    position: relative;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 100%;
    transform: scale(1.5);
    transition: all 2s ease;
    &.active {
      background-position: 30% 100%;
      transform: scale(1);
    }
  }
}

@media (max-width: 1800px) {
  .image-component {
    height: 667px;
  }
}
@media (max-width: 768px) {
  .image-component {
    height: 400px;
    margin: 50px 0 50px 0;
    .image-dida {
      bottom: 10px;
      left: 10px;
    }
  }
}
</style>
